import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
    collapsed: boolean;
    mobileOpen: boolean;
    toggleCollapsed: () => void;
    setMobileOpen: (open: boolean) => void;
}

export const useSidebarStore = create<SidebarState>()(
    persist(
        (set) => ({
            collapsed: false,
            mobileOpen: false,
            toggleCollapsed: () => set((state) => ({ collapsed: !state.collapsed })),
            setMobileOpen: (mobileOpen) => set({ mobileOpen }),
        }),
        {
            name: 'safarapi.console.sidebar',
            partialize: (state) => ({ collapsed: state.collapsed }),
        },
    ),
);
